import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  FormGroup, FormControl, Button,
} from 'react-bootstrap';
import { trim } from 'lodash';
import Fa from 'react-fontawesome';


class JobForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitting: false,
      currentJob: '',
    };
    this.handleChange = this.handleChange.bind(this);
    this.hanldeSubmit = this.hanldeSubmit.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
    this.checkProps(this.props.job);
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  checkProps(job) {
    const currentJob = job ? (job.job || '') : '';
    this.setState({ currentJob });
  }

  handleChange(event) {
    this.setState({ currentJob: event.target.value });
  }

  hanldeSubmit() {
    const { currentJob } = this.state;
    if (currentJob && trim(currentJob).length > 0) {
      this.setState({ submitting: true }, () => {
        this.props.requestSubmit(this.props.job, currentJob)
          .then(
            () => {
              this.setState({ submitting: false });
            },
            () => {
              this.setState({ submitting: false });
            },
          );
      });
    }
  }

  render() {
    const { submitting, currentJob } = this.state;
    const { job, showCancel } = this.props;
    const isNew = !job || !job._id;
    let lbl = null;
    let fa = null;

    if (submitting) {
      fa = 'spinner';
      if (isNew) {
        lbl = 'Adding';
      } else {
        lbl = 'Updating';
      }
    } else if (isNew) {
      fa = 'plus';
      lbl = 'Add Job';
    } else {
      fa = 'edit';
      lbl = 'Update Job';
    }

    const valid = currentJob && trim(currentJob).length > 0;

    return (
      <div>
        <FormGroup>
          <FormControl
            value={currentJob}
            componentClass="textarea"
            placeholder="enter job"
            disabled={submitting}
            onChange={this.handleChange}
          />
        </FormGroup>
        <div className="clearfix">
          {showCancel &&
            <Button
              bsStyle="default"
              className="pull-left"
              bsSize="sm"
              disabled={submitting}
              onClick={this.props.requestCancel}
            >
              <Fa name="times" /> Cancel
            </Button>
          }
          <Button
            bsStyle="primary"
            className="pull-right"
            bsSize="sm"
            disabled={(submitting || !valid)}
            onClick={this.hanldeSubmit}
          >
            {fa !== null && <Fa name={fa} spin={submitting} />} {(fa !== null && ' ')} {lbl}
          </Button>
        </div>
      </div>
    );
  }
}

JobForm.propTypes = {
  job: PropTypes.shape({
    job: PropTypes.string,
    _id: PropTypes.string,
  }),
  showCancel: PropTypes.bool,
  requestSubmit: PropTypes.func,
  requestCancel: PropTypes.func,
};

JobForm.defaultProps = {
  job: {
    job: '',
  },
  showCancel: false,
  requestCancel: () => {},
  requestSubmit: () => Promise.reject(new Error('need handler')),
};


export default JobForm;
